const MathHelper = {
  subtractAmounts: (num1: number, num2: number, precision: number = 2) => {
    return Number((num1 - num2).toFixed(precision));
  },

  addAmounts: (num1: number, num2: number, precision: number = 2) => {
    return Number((num1 + num2).toFixed(precision));
  },

  toFixedNoRound: (number: number, precision: number = 1) => {
    const factor = Math.pow(10, precision);
    const scaled = number * factor;
    // Snap to the nearest integer only when scaled is within binary floating-point
    // error of it, then truncate toward zero. This strips representation noise
    // (e.g. 141.77 * 100 = 14177.000000000002) without rounding genuine values
    // across the boundary, and uses Math.trunc instead of Math.floor — Math.floor
    // rounds toward -Infinity, so negative amounts drifted 1 unit "more negative"
    // (a -141.77 receipt produced a -141.78 cost-center tag).
    // The tolerance is a few ULPs of the scaled value (noise scales with magnitude)
    // floored at 1e-9. Unlike a plain 1e-9 * |scaled|, this can never approach 0.5,
    // so it never snaps a genuine sub-unit value on large amounts (e.g. a 5 000 000
    // kr split producing x.005 must still truncate to x.00, not round to x.01).
    const nearest = Math.round(scaled);
    const tolerance = Math.max(4 * Number.EPSILON * Math.abs(scaled), 1e-9);
    const guarded = Math.abs(scaled - nearest) <= tolerance ? nearest : scaled;
    return Math.trunc(guarded) / factor;
  },

  /** Rounds half away from zero, treating a value within binary noise of the half (1.005) as the half. */
  roundAmount: (number: number, precision: number = 2) => {
    const factor = Math.pow(10, precision);
    const scaled = Math.abs(number * factor);
    // Same tolerance as toFixedNoRound: a few ULPs, so it can never lift a genuine sub-half value.
    const tolerance = Math.max(4 * Number.EPSILON * scaled, 1e-9);
    return (Math.sign(number) * Math.floor(scaled + 0.5 + tolerance)) / factor;
  },
};

export default MathHelper;
